import { RSAccountStatSetResponse } from '../data/rsTypes';

export const isLegacyEntitlements = (accountStatSet: RSAccountStatSetResponse) => {
	return (
		accountStatSet.entitlementEvaluation.entitled &&
		!accountStatSet.entitlementEvaluation.evaluationResult.isPaywallEnabled
	);
};
